import { render, staticRenderFns } from "./JobInterestsStatistics.vue?vue&type=template&id=0782822c&"
import script from "./JobInterestsStatistics.vue?vue&type=script&lang=js&"
export * from "./JobInterestsStatistics.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports